import React from 'react';
import {
  IonItem,
  IonLabel,
  IonButton,
  IonAlert,
  IonInput,
  IonCheckbox,
  IonRow,
  IonCol,
  IonIcon,
  IonGrid,
} from '@ionic/react';
import Loading from '../../components/spinner';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import {
  Title,
  Spacer,
  NormalText,
  Subtitle,
  SmallText,
  StrongText,
  MediumText,
} from '../../components/common';
import { connect } from 'react-redux';
import Basket from '../../lib/basket';
import {
  forwardTo,
  goBack,
  isDefined,
  isEmailValid,
  isEmptyObject,
  validateProfileData,
  deepCopy,
} from '../../lib/utils';
import './index.css';
import Modal from '../../components/modal';
import {
  removePaymentCard,
  removeVoucher,
  setCommonModal,
  setCommonProp,
  updateProfile,
} from '../../store/actions';
import moment from '../../lib/moment';
import Mobiscroll from '../../components/mobiscroll';
import { checkSnoozedTimes, formatDataForTime } from '../clickAndCollect';
import { getConfig } from '../../appConfig';
import { CANCEL_PAYMENT_INTENT, GET_TAX, REGISTER_REQUEST, SET_COMMON_PROP } from '../../store/constants';
import { chevronBack, chevronForward, closeOutline } from 'ionicons/icons';
import { ReactComponent as TicketSvg } from '../../assets/images/ticket.svg';
import OrderContent from '../../components/orderContent';
import { ReactComponent as TrashIcon } from '../../assets/images/trash.svg';
import { ReactComponent as PaymentIcon } from '../../assets/images/payment-icon.svg';
import { ApplyAllergens } from '../allergens';
import MobileInput from '../../components/mobileInput';
import BlockSeparator from '../../components/blockSeparator';

const { SelectOption } = Mobiscroll;
const { getMobile, setMobile } = Basket;

class Checkout extends React.Component {
  constructor(props) {
    super(props);

    const defaultCard =
      this.props.cards.length > 0 &&
      this.props.profile.cardToken &&
      this.props.cards.find((card) => card.id === this.props.profile.cardToken);
    this.state = {
      selectedCard: defaultCard,
      defaultCard: defaultCard,
      selectedJudopayCard: null,
      collectedModal: false,
      collectedPay: this.props.cards.length === 0,
      showAllCards: false,
      pickTime: null,
      removeCardAlert: null,
      email: '',
      name: this.props.profile?.first_name ?? '',
      receiveUpdates: getConfig().flags?.hasMarketingOptInChecked ?? false,
      modalOpen: false,
      enterNameModal: false,
      flash: false,
      newEmail: '',
      update: false,
      tableNumberPickerOpen: false,
      tableNumber: Basket.getTableNumber(),
      allergenModalOpenWithButton: false,
      mobile_code: this.props.profile.mobile_code ? this.props.profile.mobile_code : null,
      mobile_value: this.props.profile.mobile_value ? this.props.profile.mobile_value : this.props.profile.mobile == this.props.profile.mobile_code ? '' : this.props.profile.mobile,
      mobile: this.props.profile.mobile || '',

    };
    this.updateHandler = this.updateHandler.bind(this);
  }
  setMobileCode = (val) => {
    this.setState({ mobile_code: val, mobile: `${val}${this.state.mobile_value}` });
  };
  setMobileValue = (val) => {
    this.setState({ mobile_value: val, mobile: `${this.state.mobile_code}${val}` });
  };
  componentDidMount() {
    const { profile } = this.props;
    if (profile.cardToken) {
      this.changeSelectedPaymentCard(profile.cardToken);
    }
    this.setState({
      newEmail: isEmailValid(this.props.profile.email) ? this.props.profile.email : '',
    });
    this.props.dispatch({ type: SET_COMMON_PROP, key: 'checkoutInstructionsModal', value: false });
  }
  handleOrderItemClick = (item, index, quantity, restaurant) => {
    Basket.changeItemQuantity(index, quantity, false, restaurant);
    // this.setState({ quantityModal: { item, index } });
  };
  componentDidUpdate(prevProps) {
    const { profile } = this.props;
    if (!this.state.collectedPay) {
      if (prevProps.profile.cardToken !== profile.cardToken) {
        this.changeSelectedPaymentCard(profile.cardToken);
      }
    }
  }

  changeSelectedPaymentCard = (cardId) => {
    if (cardId !== 'collectedPay') {
      const selectedCard = this.props.cards.find((card) => card.id === cardId);
      this.setState({ selectedCard, defaultCard: selectedCard, collectedPay: false }, () => {
        Basket.changeSelectedCard(cardId);
      });
    } else {
      this.setState({ collectedPay: true, selectedCard: null }, () => { });
    }
  };

  backHandler = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.skipContactDetails
    ) {
      forwardTo('/order', { skipBackToThePreviousPage: true, selectedMenu: [] });
    } else if (this.props.location.pathname === '/checkout') {
      forwardTo('/order', { skipBackToThePreviousPage: true, selectedMenu: [] });
    } else {
      goBack();
    }
  };

  updateHandler = () => {
    this.setState({
      update: true,
    });
  };

  showCollectedModal(modalOpen) {
    this.setState({ collectedModal: modalOpen });
  }
  changeTime = (selectedTime, minDT) => {
    let h = parseInt(selectedTime.split(':')[0]);
    let m = parseInt(selectedTime.split(':')[1]);
    const formattedDT = moment(minDT).hours(h).minutes(m);
    Basket.setCollectionTime(formattedDT);
  };

  setPickTime = (inst, minDT) => {
    if (inst.getVal()) {
      this.changeTime(inst.getVal(), minDT);
      this.setState({ pickTime: inst.getVal() });
    }
  };

  removePaymentCard = () => {
    const { __ } = this.props;
    this.props.dispatch(
      removePaymentCard(this.state.removeCardAlert, {
        __,
        cb: () => this.setState({ removeCardAlert: null }),
      }),
    );
  };

  handleRemoveCardAlert = (cardId) => this.setState({ removeCardAlert: cardId });

  createKioskOrder = () => {
    const kioskConfiguration = getConfig().kiosk;
    Basket.createOrder(kioskConfiguration.acceptPayment ? 'kiosk' : 'collectedPay', null, () =>
      forwardTo('/order-completed'),
    );
  };

  handleKioskGuestReigister() {
    const { registerFormData, kioskData, profile } = this.props;
    const { email, name, receiveUpdates, newEmail, mobile, mobile_code, mobile_value } = this.state;
    const timestamp = new Date().getTime();
    const { kiosk_auth_email, kiosk_password } = kioskData;
    if (isEmptyObject(profile || {})) {
      if (newEmail !== '' && newEmail && isEmailValid(newEmail)) {
        registerFormData.email = `${timestamp}_${newEmail}`;

      } else {
        registerFormData.email = `${timestamp}_${email ? email : kiosk_auth_email ?? 'guest@5loyalty.com'}`;

      }
      registerFormData.first_name = name;
      registerFormData.is_subscribed = receiveUpdates;
      registerFormData.accepted_terms_and_conditions = true;
      registerFormData.guest = true;
      registerFormData.password = timestamp;
      registerFormData.mobile = mobile;
      registerFormData.mobile_value = mobile_value;
      registerFormData.mobile_code = mobile_code;

      this.props.dispatch({
        type: REGISTER_REQUEST,
        referrer: '/checkout',
        guest: true,
        cb: () => this.createKioskOrder(),
      });
    } else if (profile.first_name !== name) {
      this.props.dispatch(
        updateProfile({
          first_name: name,
          last_name: profile.last_name,
          email: profile.email,
        }),
      );
      this.createKioskOrder();
    } else {
      this.createKioskOrder();
    }

    this.setState({ enterNameModal: false });
  }
  onChange = (val) => {
    this.setState({ tableNumber: val == '' ? null : val });
  };

  processOrder = () => {
    const force_allergen = getConfig()?.flags ? getConfig().flags.force_allergen : false;
    if (Basket.getAllergen().length > 0 && force_allergen) {
      this.setState({ allergenModalOpenWithButton: true }, () => {
        this.props.dispatch(setCommonProp('allergenModalOpen', true))

      })

    } else {
      this.setState({ enterNameModal: true })

    }
  }
  getTax() {
    const uuid = `${this.props.profile.id ?? 'guest'}_${Date.now()}`;
    Basket.setUUID(uuid, true);
    if (Basket._getServiceCharge() === 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type) && getConfig().flags.hasServiceChargeAlertPrompt) {
      this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', true));
    } else {
      let data = Basket.has_multi_basket
        ? deepCopy(Basket.multi_basket_items)
        : [
          {
            restaurant: { business_location_id: Basket.getRestaurant()?.business_location_id },
            items: Basket.items,
          },
        ];
      const additionalData = Basket.getAdditionalTaxData();
      if (additionalData) {
        data.push(additionalData);
      }
      this.props.dispatch({ type: GET_TAX, data, includeAll: true });
    }
  }
  cancelTaxCalculation = () => {
    const { dispatch } = this.props;
    dispatch(setCommonProp('taxCalculated', false));
    dispatch(setCommonProp('taxContentLoading', false));
    dispatch(setCommonProp('taxCanceled', true));
  };
  render() {
    const {
      __,
      dispatch,
      deliveryTimeModalOpen,
      restaurants,
      checkoutInstructionsModal,
      profile,
      auth,
      vouchers,
      allergenModalOpen
    } = this.props;
    const {
      collectedModal,
      pickTime,
      receiveUpdates,
      flash,
      newEmail,
      name,
      allergenModalOpenWithButton,
      mobile, mobile_value, mobile_code

    } = this.state;
    const basketInstance = this.props.basketInstance || Basket;
    const isAuth = auth.loggedIn;
    const valid = validateProfileData(profile).isValid;

    let orderType = '';
    let price = '';
    let store = '';
    let snoozedTimes = '';
    let minDT = '';
    let timePickerOptions = [];
    if (Basket.getDeliveryOption().id != 'gift-vouchers') {
      if (Basket.getRestaurant()) {
        orderType = Basket.getOrderType();
        price = Basket._getTotal();
        store = restaurants.find((restaurant) => restaurant.id === Basket.getRestaurant().id);
        if (orderType == 'Table') {
          snoozedTimes = [];
        } else {
          snoozedTimes = checkSnoozedTimes(store, Basket.getDeliveryOption().id);
        }
        minDT = moment();
        if (Basket.getDeliveryOption().id == 'charter-delivery') {
          if (store && isDefined(store.charter_delivery_order_slot_lead_time)) {
            minDT.add(store.charter_delivery_order_slot_lead_time, 'minutes');
          }
        } else {
          if (store && isDefined(store.order_slot_lead_time)) {
            minDT.add(store.order_slot_lead_time, 'minutes');
          }
        }

        timePickerOptions = formatDataForTime(
          Basket.getRestaurant(),
          minDT,
          Basket.getRestaurant().id,
          Basket.getDeliveryOption().id === 'charter-delivery' ? true : false,
          false,
          snoozedTimes,
        );
      }
    }
    const appliedVoucher = Basket.getAppliedVoucher();
    const appliedPoints = Basket.getAppliedPoints();
    let fullscreenBasket =
      JSON.parse(localStorage.getItem('kioskData'))?.full_screen_basket_mode ?? false;
    const showVouchers = (Basket.has_square_taxes && Basket.getTaxBreakdown().length > 0) || (!Basket.has_square_taxes && (Basket.getTaxBreakdown().length > 0 || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown));

    return (
      <>
        <Loading transparent>
          <Layout
            blank
            onPayButtonSubmitHandler={() => this.setState({ enterNameModal: true })}
            showPayButton={fullscreenBasket}
            scrollY={false}
            color="transparent"
            headerTitle={__('Checkout')}
            headerWithTitle={true}
            backHandler={this.backHandler}
            disableForwardTo={true}
          >
            {this.state.enterNameModal ?
              <div className='absolute-content'>   
              <div className='checkout-wrapper  small-padding scrollable-y flex-row-wrapper flex-align-center'>
                <div className='page-close' onClick={() => this.setState({ enterNameModal: false })}>
                  <IonIcon icon={closeOutline} />
                </div>
                <div className='centered'>
                  <Title className="large-title block ">{__('Enter your name')}</Title>

                  <Spacer size={2} />

                  <Subtitle className="text-color block centered">
                    {__(`Enter your name below and we will call you when your order is ready`)}
                  </Subtitle>
                </div>

                <Spacer size={5} />
                <div className='checkout-form'>
                  <div className='input-field-container'>
                    <Subtitle>{__('Your name')}</Subtitle>
                    <IonItem lines="none" className="input-field-wrapper input-field-wrapper-large">
                      <IonInput
                        onIonInput={(e) => {
                          this.setState({ name: e.target.value });
                        }}
                        color="primary"
                        required={true}
                        value={name}
                        autocomplete="on"
                        placeholder={__('Name')}

                      />
                    </IonItem>
                  </div>
                  <div className='input-field-container'>
                    <Subtitle>{__('Your mobile')}</Subtitle>

                    <MobileInput mobile_code={mobile_code} mobile_value={mobile_value} setMobileCode={this.setMobileCode} setMobileValue={this.setMobileValue} />
                  </div>
                  <BlockSeparator text={__('Optional - for your receipt')} />
                  <div className='input-field-container'>
                    <Subtitle>{__('Your email')}</Subtitle>
                    <IonItem
                      lines="none"
                      className={`input-field-wrapper  input-field-wrapper-large ${flash && 'flash-field'}`}
                    >
                      <IonInput
                        onIonInput={(e) => {
                          this.setState({ flash: false, newEmail: e.target.value });
                        }}
                        required={false}
                        type="email"
                        pattern="email"
                        inputmode="email"
                        value={newEmail}
                        autocomplete="on"
                        placeholder={__('Email')}
                      ></IonInput>
                    </IonItem>
                  </div>





                <IonButton
                expand='block'
                  onClick={() => this.handleKioskGuestReigister()}
                  color="primary"
                  className="large-button"
                  disabled={!(name.trim() !== '' && mobile_value !== '')}
                >
                  {__('Continue')}
                  <IonIcon slot='end' icon={chevronForward} />
                </IonButton>
                <Spacer size={4}/>
                <div className="register-terms-wrapper">
                  <IonCheckbox
                    color="primary"
                    checked={receiveUpdates}
                    onIonChange={(e) => this.setState({ receiveUpdates: e.detail.checked })}
                  />
                  <IonLabel className="ion-text-wrap" onClick={() => { this.setState({ receiveUpdates: !this.state.receiveUpdates }) }}>
                    <NormalText color="primary">
                      {__('Opt-in to receive updates, offers and promotions via email')}
                    </NormalText>
                  </IonLabel>
                </div>


              </div></div>
                              </div>


              :
              <div className='absolute-content kiosk-basket'>
                <div className='flex-justify-between flex-col-wrapper flex-align-center '>
                  <Title>{Basket.order_type == 'kiosk-table' ? __('Eat in order') : __('Pick up order')}</Title>
                  {Basket.getAllergen().length > 0 && (
                    <IonButton
                      onClick={() =>
                        dispatch({ type: SET_COMMON_PROP, key: 'allergenModalOpen', value: true })
                      }
                      className="small-button"
                      color='primary'
                      fill='clear'
                    >
                      {__('View Allergens')}
                    </IonButton>
                  )}
                </div>

                <OrderContent handleOrderItemClick={this.handleOrderItemClick} />
                {isAuth &&
                  getConfig().kiosk.hasLoyalty &&
                  (vouchers.length > 0 || profile.available_balance > 0) && (
                    <>
                      <div className="basket-loyalty-wrapper">
                        {!valid && getConfig().appType.hasEmailValidationEnabled ? (
                          <>
                            {isAuth && !valid && getConfig().appType.hasEmailValidationEnabled ? (
                              <NormalText className="centered block">
                                {__(
                                  'You can earn, but not redeem points until your account is verified',
                                )}
                              </NormalText>
                            ) : null}
                          </>
                        ) : (
                          <>
                            {appliedVoucher.length == 0 && !appliedPoints && showVouchers ? (
                              <div className='basket-loyalty-options'>
                                {(!getConfig().kiosk.removeVouchers && vouchers.length > 0) && (
                                  <div
                                    className="box-content box-shadow"
                                    onClick={() => this.props.dispatch(setCommonProp('vouchersModalOpen', true))}
                                  >
                                    <TicketSvg />
                                    <div>
                                      <StrongText className="block primary-color" style={{ marginBottom: "10px" }}>
                                        {__('Apply a voucher')}
                                      </StrongText>
                                      <SmallText className="block  bold">{`${vouchers.length
                                        } ${__('available')}`}</SmallText>
                                    </div>
                                    <IonIcon icon={chevronForward} />
                                  </div>
                                )}

                                {(!getConfig().kiosk.removePoints && profile.available_balance > 0) && (
                                  <div
                                    className="box-content box-shadow"
                                    onClick={() => this.props.dispatch(setCommonProp('pointsModalOpen', true))}
                                  >
                                    <TicketSvg />

                                    <div>
                                      <StrongText className="block primary-color" style={{ marginBottom: "10px" }}>
                                        {__('Redeem points')}
                                      </StrongText>
                                      <SmallText className="block  bold">
                                        {`${profile.available_balance?.toLocaleString()} ${__(
                                          'points available',
                                        )}`}
                                      </SmallText>
                                    </div>
                                    <IonIcon icon={chevronForward} />
                                  </div>
                                )}
                              </div>
                            ) : (
                              <IonGrid class='applied-loyalty-row'>
                                {appliedPoints ? (
                                  <IonRow className="box-content">
                                    <IonCol className="paddLR grow flex-col-wrapper flex-align-center" style={{ gap: '30px' }}>

                                      <MediumText>{__('Applied points')}</MediumText>
                                      <div className='remove-btn' onClick={() => {
                                        Basket.applyPoints(0, () => { });
                                        this.setState({ update: true });
                                      }}>
                                        <TrashIcon />
                                      </div>

                                    </IonCol>
                                    <IonCol className=" paddLR  " style={{ height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                      <MediumText>{Basket._calculatePointsAppliedPrice(null, true)}</MediumText>
                                    </IonCol>
                                  </IonRow>
                                ) : null}
                                {appliedVoucher.length > 0 ? (
                                  <IonRow className="box-content">
                                    <IonCol className="paddLR grow flex-col-wrapper flex-align-center" style={{ gap: '30px' }}>
                                      <MediumText>
                                        {__('Applied voucher')}
                                      </MediumText>

                                      <div className='remove-btn' onClick={() => {
                                        this.props.dispatch(removeVoucher(appliedVoucher[0].id));
                                        this.setState({ update: true });
                                      }}>
                                        <TrashIcon />
                                      </div>


                                    </IonCol>
                                    <IonCol className=" paddLR  " style={{ height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                      <MediumText>{Basket._calculateAppliedVocuhersPrice(true, null)}</MediumText>
                                    </IonCol>
                                  </IonRow>
                                ) : null}
                              </IonGrid>
                            )}
                          </>
                        )}
                      </div>
                    </>
                  )}
                <div className='checkout-actions'>
                  <div className='large-button circle-button' onClick={() => goBack()}><IonIcon icon={chevronBack} /></div>
                  <div className='checkout-button-wrapper'>

                    {Basket.getTaxBreakdown().length > 0 || this.props.taxCalculated || !getConfig().flags.hasTaxBreakdown ?
                      <IonButton className='large-button'
                        disabled={basketInstance.itemsCount() === 0}
                        onClick={() => this.processOrder()}

                        expand="block">
                        <IonGrid>
                          <IonRow>
                            <IonCol class='view-order-count'>
                              {Basket.itemsCountAll()}
                            </IonCol>

                            <IonCol>{__('Total to pay')}</IonCol>

                            <IonCol>{Basket._getTotal(true)}</IonCol>
                          </IonRow>
                        </IonGrid>
                      </IonButton>
                      : <>
                        <IonButton onClick={() => this.getTax()} className='large-button'>{__('Finalize order')}</IonButton>
                      </>}
                  </div>

                </div>
              </div>

            }

          </Layout>
          <IonAlert
            isOpen={collectedModal}
            onDidDismiss={() => this.showCollectedModal(false)}
            header={__('Pay on Collection')}
            message={__(
              'You agree to pay the amount shown before collecting your order. Earned loyalty will be updated after payment',
            )}
            buttons={[
              {
                text: __('Cancel'),
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => this.showCollectedModal(false),
              },
              {
                text: __('Confirm'),
                handler: () => {
                  Basket.createOrder('collectedPay');
                  this.showCollectedModal(false);
                },
              },
            ]}
          />
        </Loading>
        {allergenModalOpen &&
          <Modal
            title={__('Allergen information')}
            showBackArrow
            isOpen={allergenModalOpen}
            onDidDismiss={() =>
              this.props.dispatch({
                type: SET_COMMON_PROP,
                key: 'allergenModalOpen',
                value: false,
              })
            }
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center' }}>
              <ApplyAllergens />
              {allergenModalOpenWithButton &&
                <>
                  <Spacer size={3} />
                  <IonButton onClick={() => {
                    this.setState({
                      allergenModalOpenWithButton: false, enterNameModal: true
                    }, () => {
                      this.props.dispatch(setCommonProp('allergenModalOpen', false))
                    })

                  }} className='large-button' color={'primary'}>
                    {__('Continue')}
                    <IonIcon slot='end' icon={chevronForward} />
                  </IonButton>
                </>
              }
            </div>
          </Modal>}
        {deliveryTimeModalOpen && (
          <Modal
            className={'delivery-time-modal'}
            isOpen={deliveryTimeModalOpen}
            onDidDismiss={() => dispatch(setCommonModal('deliveryTimeModalOpen', false))}
          >
            <Title>{__('Select Collection Time')}</Title>
            <NormalText>{__('Please select different time')}</NormalText>
            <Spacer />
            <SelectOption
              display="inline"
              onSet={(e, inst) => this.setPickTime(inst, minDT)}
              data={timePickerOptions}
              label="Location"
              value={pickTime}
              inputStyle="box"
              placeholder={__('Select Collection Time')}
              setText={__('OK')}
              cancelText={__('Cancel')}
              onInit={() => {
                if (timePickerOptions.length > 0) {
                  const firstAvailableTime = timePickerOptions.find((i) => !i.disabled);
                  if (!pickTime && firstAvailableTime && pickTime !== firstAvailableTime.value) {
                    this.changeTime(firstAvailableTime.value, minDT);
                  }
                }
              }}
            />
            <Spacer />
            <IonButton
              expand="block"
              color="primary"
              className="uppercase okx-font-secondary"
              onClick={() => dispatch(setCommonModal('deliveryTimeModalOpen', false))}
            >
              {__('Continue')}
            </IonButton>
          </Modal>
        )}

        <Modal
          isOpen={checkoutInstructionsModal === true}
          onDidDismiss={() =>
            this.props.dispatch({
              type: SET_COMMON_PROP,
              key: 'checkoutInstructionsModal',
              value: false,
            })
          }
        >
          <div className='large-padding text-centered grid-wrapper grid-justify-center grid-align-start'>
            <Title className="large-title">{__('Present your payment card')}</Title>
            <Spacer size={2} />
            <Subtitle className='text-color'>{__('Follow instructions on the terminal')}</Subtitle>
            <Spacer size={2} />
            <div className='icon-wrapper'>
              <PaymentIcon />
            </div>
            <Spacer size={2} />

            <IonButton
              color="secondary"
              className="large-button"
              onClick={() => dispatch({ type: CANCEL_PAYMENT_INTENT })}
            >
              {__('Abort Payment')}
            </IonButton>
          </div>
        </Modal>
        <IonAlert
          isOpen={isDefined(this.state.removeCardAlert)}
          onDidDismiss={() => this.handleRemoveCardAlert(null)}
          header={__('Confirm')}
          message={__('Do you you want to remove this card?')}
          buttons={[
            {
              text: __('Cancel'),
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
              text: __('Remove'),
              handler: () => this.removePaymentCard(),
            },
          ]}
        />
        <IonAlert
          backdropDismiss={false}
          isOpen={this.props.taxContentLoading}
          header={__('Calculating taxes')}
          message={`<div class="tax-alert"><ion-spinner ></ion-spinner> <span class="medium-text">${__('Please wait whilst we calculate taxes')}</span></div>`}
          buttons={[
            {
              text: __('Cancel'),
              role: 'cancel',
              cssClass: 'primary',
              handler: () => this.cancelTaxCalculation(),
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  const { auth, registerFormData, kioskData, profile, vouchers } = store.profile;
  const { checkoutInstructionsModal, allergenModalOpen, allergenModalOpenWithButton, taxContentLoading, taxCalculated } = store.common;
  return {
    cards: store.orders.cards || [],
    clientSecret: store.orders.clientSecret,
    profile: store.profile.profile || {},
    deliveryTimeModalOpen: store.common.deliveryTimeModalOpen,
    restaurants: store.restaurants.restaurants || [],
    registerFormData,
    kioskData,
    checkoutInstructionsModal,
    profile,
    auth,
    vouchers: vouchers || [],
    allergenModalOpen, allergenModalOpenWithButton,
    taxContentLoading,
    taxCalculated
  };
};

export default connect(mapStateToProps)(withTranslation(Checkout));
